import React from "react";
import { useTranslation } from "react-i18next";
import { Divider, Stack } from "@mui/material";

import Button from "components/basic/button";

interface ModalFooterProps {
  isEdit: boolean;
  isValid: boolean;
  saving: boolean;
  onClose: () => void;
  onSave: () => void;
}

const ModalFooter: React.FC<ModalFooterProps> = ({
  isEdit,
  isValid,
  saving,
  onClose,
  onSave,
}) => {
  const { t } = useTranslation("calendar");

  return (
    <>
      <Divider sx={{ my: 2 }} />
      <Stack direction="row" spacing={1.5} justifyContent="flex-end">
        <Button
          variant="outlined"
          color="primary"
          onClick={onClose}
          disabled={saving}
        >
          {t("booking.cancel")}
        </Button>
        <Button
          variant="contained"
          color="warning"
          disabled={!isValid || saving}
          loading={saving}
          onClick={onSave}
        >
          {isEdit ? t("booking.save_changes") : t("booking.save")}
        </Button>
      </Stack>
    </>
  );
};

export default ModalFooter;
